var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "task-filter-bar" } }, [
    _c(
      "div",
      { staticClass: "filter-section" },
      [
        _c("div", { staticClass: "filter-toolbar" }, [
          _c(
            "div",
            { staticClass: "search-bar" },
            [
              _c("a-input", {
                ref: "searchInput",
                staticClass: "modern-search-input",
                attrs: { placeholder: "Görevlerde ara..." },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleSearch.apply(null, arguments)
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "prefix",
                    fn: function () {
                      return [
                        _c(
                          "span",
                          { staticClass: "material-icons search-icon" },
                          [_vm._v("search")]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.localSearchQuery,
                  callback: function ($$v) {
                    _vm.localSearchQuery = $$v
                  },
                  expression: "localSearchQuery",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "avatar-content",
              staticStyle: { display: "flex", "align-items": "center" },
            },
            [
              _c(
                "div",
                {
                  class: [
                    "avatar-container",
                    { selected: _vm.isUserSelected("notAppointed") },
                  ],
                  style: {
                    border: _vm.isUserSelected("notAppointed")
                      ? "2px solid #47499d"
                      : "2px solid #e8e8e8",
                    borderRadius: "50%",
                    marginRight: "8px",
                    backgroundColor: "white",
                    zIndex: _vm.isUserSelected("notAppointed") ? "10" : "5",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.toggleUserSelection("notAppointed")
                    },
                  },
                },
                [
                  _c("Avatar", {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                        },
                        expression:
                          "{\n                            followCursor: true,\n                            placement: 'bottom-end',\n                        }",
                      },
                    ],
                    key: 1,
                    staticStyle: { cursor: "pointer" },
                    attrs: {
                      size: 30,
                      username: _vm.$t("message.notAppointed"),
                      src: "https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp",
                      content: _vm.$t("message.notAppointed"),
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.visibleUsers, function (user, index) {
                return _c(
                  "div",
                  { key: user._id, staticClass: "avatar-wrapper" },
                  [
                    _c(
                      "div",
                      {
                        class: [
                          "avatar-container",
                          { selected: _vm.isUserSelected(user._id) },
                        ],
                        style: {
                          border: _vm.isUserSelected(user._id)
                            ? "2px solid #47499d"
                            : "2px solid white",
                          borderRadius: "50%",
                          marginLeft: index > 0 ? "-8px" : "0px",
                          zIndex: _vm.isUserSelected(user._id) ? 10 : 5 - index,
                          backgroundColor: "white",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.toggleUserSelection(user._id)
                          },
                        },
                      },
                      [
                        _c("Avatar", {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                followCursor: true,
                                placement: "bottom-end",
                              },
                              expression:
                                "{\n                                followCursor: true,\n                                placement: 'bottom-end',\n                            }",
                            },
                          ],
                          key: 1,
                          staticStyle: { cursor: "pointer" },
                          attrs: {
                            size: 30,
                            username: user.name,
                            src: user.gravatar,
                            content: user.name,
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                )
              }),
              _vm._v(" "),
              _vm.remainingUsers.length > 0
                ? _c("div", { staticClass: "custom-dropdown-container" }, [
                    _c(
                      "div",
                      {
                        staticClass: "avatar-container remaining-indicator",
                        class: { active: _vm.isRemainingUsersOpen },
                        style: {
                          border: "none",
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "34px",
                          height: "34px",
                          cursor: "pointer",
                          backgroundColor: "#47499d",
                          color: "white",
                          fontSize: "14px",
                          marginLeft: "-8px",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                          zIndex: "1",
                        },
                        on: { click: _vm.toggleRemainingUsers },
                      },
                      [
                        _vm._v(
                          "\n                        +" +
                            _vm._s(_vm.remainingUsers.length) +
                            "\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.isRemainingUsersOpen
                      ? _c(
                          "div",
                          {
                            ref: "customDropdown",
                            staticClass: "custom-dropdown",
                          },
                          [
                            _c("div", { staticClass: "dropdown-arrow" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "dropdown-header" }, [
                              _c(
                                "div",
                                { staticClass: "dropdown-header-top" },
                                [
                                  _c("span", [_vm._v("Diğer Kullanıcılar")]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "dropdown-close",
                                      on: { click: _vm.closeRemainingUsers },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "material-icons" },
                                        [_vm._v("close")]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dropdown-search" },
                                [
                                  _c("a-input", {
                                    staticClass: "dropdown-search-input",
                                    attrs: { placeholder: "Kullanıcı ara..." },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "prefix",
                                          fn: function () {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "material-icons search-icon",
                                                },
                                                [_vm._v("search")]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      2038016488
                                    ),
                                    model: {
                                      value: _vm.remainingUsersSearchQuery,
                                      callback: function ($$v) {
                                        _vm.remainingUsersSearchQuery = $$v
                                      },
                                      expression: "remainingUsersSearchQuery",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "dropdown-content" },
                              _vm._l(
                                _vm.filteredRemainingUsers,
                                function (user) {
                                  return _c(
                                    "div",
                                    {
                                      key: user._id,
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleUserSelection(
                                            user._id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          class: [
                                            "avatar-container",
                                            {
                                              selected: _vm.isUserSelected(
                                                user._id
                                              ),
                                            },
                                          ],
                                          style: {
                                            border: _vm.isUserSelected(user._id)
                                              ? "2px solid #47499d"
                                              : "2px solid #e8e8e8",
                                            borderRadius: "50%",
                                            backgroundColor: "white",
                                          },
                                        },
                                        [
                                          _c("Avatar", {
                                            key: 1,
                                            staticStyle: { cursor: "pointer" },
                                            attrs: {
                                              size: 30,
                                              username: user.name,
                                              src: user.gravatar,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "dropdown-item-name" },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(user.name) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.isUserSelected(user._id)
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "dropdown-item-check",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "material-icons",
                                                },
                                                [_vm._v("check")]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "filter-button" },
            [
              _c(
                "a-button",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: {
                        content: "Filtrele",
                        followCursor: true,
                        placement: "bottom-end",
                      },
                      expression:
                        "{\n                        content: 'Filtrele',\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                    },
                  ],
                  class: [
                    "custom-filter-button",
                    {
                      "active-filter":
                        _vm.isFilterModalOpen || _vm.activeFilterCount > 0,
                    },
                  ],
                  on: { click: _vm.toggleFilterModal },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "material-icons",
                      staticStyle: { "font-size": "18px" },
                    },
                    [_vm._v("filter_list")]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "button-text" }, [
                    _vm._v(
                      "Filtrele" +
                        _vm._s(
                          _vm.activeFilterCount > 0
                            ? " (" + _vm.activeFilterCount + ")"
                            : ""
                        )
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.isFilterModalOpen
                    ? _c("span", { staticClass: "filter-indicator" })
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _vm.isFilterModalOpen
                ? _c(
                    "div",
                    { ref: "filterPanel", staticClass: "filter-panel" },
                    [
                      _c("div", { staticClass: "filter-panel-arrow" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "filter-panel-content" }, [
                        _c("div", { staticClass: "filter-header" }, [
                          _c("h3", [_vm._v("Filtrele")]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "filter-header-actions" },
                            [
                              _c(
                                "a-button",
                                {
                                  staticClass: "reset-button",
                                  attrs: { type: "link" },
                                  on: { click: _vm.resetFilters },
                                },
                                [_vm._v("Filtreleri temizle")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-button",
                                {
                                  staticClass: "apply-button",
                                  attrs: { type: "primary" },
                                  on: { click: _vm.applyFilters },
                                },
                                [_vm._v("Uygula")]
                              ),
                              _vm._v(" "),
                              _c("a-button", {
                                staticClass: "close-button",
                                attrs: { type: "link", icon: "close" },
                                on: { click: _vm.closeFilterModal },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "filter-tab-layout" }, [
                          _c(
                            "div",
                            { staticClass: "filter-tabs" },
                            _vm._l(_vm.filterTabs, function (tab) {
                              return _c(
                                "div",
                                {
                                  key: tab.key,
                                  class: [
                                    "filter-tab",
                                    { active: _vm.activeFilterTab === tab.key },
                                  ],
                                  on: {
                                    click: function ($event) {
                                      _vm.activeFilterTab = tab.key
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(tab.title) +
                                      "\n                                    "
                                  ),
                                  _vm.hasActiveFilterInTab(tab.key)
                                    ? _c("span", {
                                        staticClass: "tab-filter-indicator",
                                      })
                                    : _vm._e(),
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "filter-tab-content" }, [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.activeFilterTab === "priorities",
                                    expression:
                                      "activeFilterTab === 'priorities'",
                                  },
                                ],
                                staticClass: "filter-tab-pane",
                              },
                              [
                                _c("div", { staticClass: "filter-options" }, [
                                  _vm._m(0),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "priority-selection" },
                                    _vm._l(_vm.priorities, function (priority) {
                                      return _c(
                                        "div",
                                        {
                                          key: priority.value,
                                          staticClass: "priority-card",
                                          on: {
                                            click: function ($event) {
                                              _vm.togglePriorityInPanel(
                                                priority.value,
                                                !_vm.localSelectedPriorities.includes(
                                                  priority.value
                                                )
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "priority-card-header",
                                              class: {
                                                selected:
                                                  _vm.localSelectedPriorities.includes(
                                                    priority.value
                                                  ),
                                              },
                                            },
                                            [
                                              _c(priority.icon, {
                                                tag: "component",
                                                staticClass: "priority-icon",
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "priority-label",
                                                },
                                                [_vm._v(_vm._s(priority.label))]
                                              ),
                                              _vm._v(" "),
                                              _c("a-checkbox", {
                                                staticClass:
                                                  "priority-checkbox",
                                                attrs: {
                                                  checked:
                                                    _vm.localSelectedPriorities.includes(
                                                      priority.value
                                                    ),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                  },
                                                  change: function (e) {
                                                    return _vm.togglePriorityInPanel(
                                                      priority.value,
                                                      e.target.checked
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "priority-card-body",
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "priority-description",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(priority.description)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                  _vm._v(" "),
                                  _vm._m(1),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.activeFilterTab === "assignees",
                                    expression:
                                      "activeFilterTab === 'assignees'",
                                  },
                                ],
                                staticClass: "filter-tab-pane",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "filter-options assignee-options",
                                  },
                                  [
                                    _vm._m(2),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "assignees-selection" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "assignee-container" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                class: [
                                                  "avatar-container",
                                                  {
                                                    selected:
                                                      _vm.isUserSelected(
                                                        "notAppointed"
                                                      ),
                                                  },
                                                ],
                                                style: {
                                                  border: _vm.isUserSelected(
                                                    "notAppointed"
                                                  )
                                                    ? "2px solid #47499d"
                                                    : "2px solid #e8e8e8",
                                                  borderRadius: "50%",
                                                  backgroundColor: "white",
                                                  zIndex: _vm.isUserSelected(
                                                    "notAppointed"
                                                  )
                                                    ? "10"
                                                    : "5",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toggleUserSelectionInPanel(
                                                      "notAppointed"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("Avatar", {
                                                  directives: [
                                                    {
                                                      name: "tippy",
                                                      rawName: "v-tippy",
                                                      value: {
                                                        followCursor: true,
                                                        placement: "bottom-end",
                                                      },
                                                      expression:
                                                        "{\n                                                            followCursor: true,\n                                                            placement: 'bottom-end',\n                                                        }",
                                                    },
                                                  ],
                                                  key: 1,
                                                  staticStyle: {
                                                    cursor: "pointer",
                                                  },
                                                  attrs: {
                                                    size: 40,
                                                    username: _vm.$t(
                                                      "message.notAppointed"
                                                    ),
                                                    src: "https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp",
                                                    content: _vm.$t(
                                                      "message.notAppointed"
                                                    ),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "assignee-name" },
                                              [
                                                _vm._v(
                                                  "\n                                                    Atanmamış\n                                                "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.filteredUsersAvatar,
                                          function (user) {
                                            return _c(
                                              "div",
                                              {
                                                key: user._id,
                                                staticClass:
                                                  "assignee-container",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    class: [
                                                      "avatar-container",
                                                      {
                                                        selected:
                                                          _vm.isUserSelected(
                                                            user._id
                                                          ),
                                                      },
                                                    ],
                                                    style: {
                                                      border:
                                                        _vm.isUserSelected(
                                                          user._id
                                                        )
                                                          ? "2px solid #47499d"
                                                          : "2px solid white",
                                                      borderRadius: "50%",
                                                      backgroundColor: "white",
                                                      zIndex:
                                                        _vm.isUserSelected(
                                                          user._id
                                                        )
                                                          ? 10
                                                          : 5,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.toggleUserSelectionInPanel(
                                                          user._id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("Avatar", {
                                                      directives: [
                                                        {
                                                          name: "tippy",
                                                          rawName: "v-tippy",
                                                          value: {
                                                            followCursor: true,
                                                            placement:
                                                              "bottom-end",
                                                          },
                                                          expression:
                                                            "{\n                                                            followCursor: true,\n                                                            placement: 'bottom-end',\n                                                        }",
                                                        },
                                                      ],
                                                      key: 1,
                                                      staticStyle: {
                                                        cursor: "pointer",
                                                      },
                                                      attrs: {
                                                        size: 40,
                                                        username: user.name,
                                                        src: user.gravatar,
                                                        content: user.name,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "assignee-name",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                    " +
                                                        _vm._s(user.name) +
                                                        "\n                                                "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.activeFilterTab === "owners",
                                    expression: "activeFilterTab === 'owners'",
                                  },
                                ],
                                staticClass: "filter-tab-pane",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "filter-options assignee-options",
                                  },
                                  [
                                    _vm._m(3),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "owner-search" },
                                      [
                                        _c("a-input", {
                                          staticClass: "owner-search-input",
                                          attrs: {
                                            placeholder: "Görev sahibi ara...",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "prefix",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "material-icons search-icon",
                                                      },
                                                      [_vm._v("search")]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            2038016488
                                          ),
                                          model: {
                                            value: _vm.ownerSearchQuery,
                                            callback: function ($$v) {
                                              _vm.ownerSearchQuery = $$v
                                            },
                                            expression: "ownerSearchQuery",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "assignees-selection" },
                                      _vm._l(
                                        _vm.filteredOwnerUsers,
                                        function (user) {
                                          return _c(
                                            "div",
                                            {
                                              key: user._id,
                                              staticClass: "assignee-container",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  class: [
                                                    "avatar-container",
                                                    {
                                                      selected:
                                                        _vm.isOwnerSelected(
                                                          user._id
                                                        ),
                                                    },
                                                  ],
                                                  style: {
                                                    border: _vm.isOwnerSelected(
                                                      user._id
                                                    )
                                                      ? "2px solid #47499d"
                                                      : "2px solid white",
                                                    borderRadius: "50%",
                                                    backgroundColor: "white",
                                                    zIndex: _vm.isOwnerSelected(
                                                      user._id
                                                    )
                                                      ? 10
                                                      : 5,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.toggleOwnerSelection(
                                                        user._id
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("Avatar", {
                                                    directives: [
                                                      {
                                                        name: "tippy",
                                                        rawName: "v-tippy",
                                                        value: {
                                                          followCursor: true,
                                                          placement:
                                                            "bottom-end",
                                                        },
                                                        expression:
                                                          "{\n                                                            followCursor: true,\n                                                            placement: 'bottom-end',\n                                                        }",
                                                      },
                                                    ],
                                                    key: 1,
                                                    staticStyle: {
                                                      cursor: "pointer",
                                                    },
                                                    attrs: {
                                                      size: 40,
                                                      username: user.name,
                                                      src: user.gravatar,
                                                      content: user.name,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "assignee-name",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                    " +
                                                      _vm._s(user.name) +
                                                      "\n                                                "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.activeFilterTab === "followers",
                                    expression:
                                      "activeFilterTab === 'followers'",
                                  },
                                ],
                                staticClass: "filter-tab-pane",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "filter-options assignee-options",
                                  },
                                  [
                                    _vm._m(4),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "follower-search" },
                                      [
                                        _c("a-input", {
                                          staticClass: "follower-search-input",
                                          attrs: {
                                            placeholder: "Takipçi ara...",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "prefix",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "material-icons search-icon",
                                                      },
                                                      [_vm._v("search")]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            2038016488
                                          ),
                                          model: {
                                            value: _vm.followerSearchQuery,
                                            callback: function ($$v) {
                                              _vm.followerSearchQuery = $$v
                                            },
                                            expression: "followerSearchQuery",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "assignees-selection" },
                                      _vm._l(
                                        _vm.filteredFollowerUsers,
                                        function (user) {
                                          return _c(
                                            "div",
                                            {
                                              key: user._id,
                                              staticClass: "assignee-container",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  class: [
                                                    "avatar-container",
                                                    {
                                                      selected:
                                                        _vm.isFollowerSelected(
                                                          user._id
                                                        ),
                                                    },
                                                  ],
                                                  style: {
                                                    border:
                                                      _vm.isFollowerSelected(
                                                        user._id
                                                      )
                                                        ? "2px solid #47499d"
                                                        : "2px solid white",
                                                    borderRadius: "50%",
                                                    backgroundColor: "white",
                                                    zIndex:
                                                      _vm.isFollowerSelected(
                                                        user._id
                                                      )
                                                        ? 10
                                                        : 5,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.toggleFollowerSelection(
                                                        user._id
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("Avatar", {
                                                    directives: [
                                                      {
                                                        name: "tippy",
                                                        rawName: "v-tippy",
                                                        value: {
                                                          followCursor: true,
                                                          placement:
                                                            "bottom-end",
                                                        },
                                                        expression:
                                                          "{\n                                                            followCursor: true,\n                                                            placement: 'bottom-end',\n                                                        }",
                                                      },
                                                    ],
                                                    key: 1,
                                                    staticStyle: {
                                                      cursor: "pointer",
                                                    },
                                                    attrs: {
                                                      size: 40,
                                                      username: user.name,
                                                      src: user.gravatar,
                                                      content: user.name,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "assignee-name",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                    " +
                                                      _vm._s(user.name) +
                                                      "\n                                                "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.activeFilterTab === "createdBy",
                                    expression:
                                      "activeFilterTab === 'createdBy'",
                                  },
                                ],
                                staticClass: "filter-tab-pane",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "filter-options assignee-options",
                                  },
                                  [
                                    _vm._m(5),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "creator-section" },
                                      [
                                        _c(
                                          "h5",
                                          {
                                            staticClass:
                                              "creator-section-title",
                                          },
                                          [
                                            _vm._v(
                                              "Sistem Tarafından Oluşturulanlar"
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "creator-types" },
                                          _vm._l(
                                            _vm.createdByTypes,
                                            function (createdByType) {
                                              return _c(
                                                "div",
                                                {
                                                  key: createdByType.type,
                                                  staticClass:
                                                    "creator-type-container",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.toggleCreatedBySelection(
                                                        createdByType.type
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      class: [
                                                        "creator-avatar",
                                                        {
                                                          selected:
                                                            _vm.isCreatedBySelected(
                                                              createdByType.type
                                                            ),
                                                        },
                                                      ],
                                                      style: {
                                                        border:
                                                          _vm.isCreatedBySelected(
                                                            createdByType.type
                                                          )
                                                            ? "2px solid #47499d"
                                                            : "2px solid transparent",
                                                        borderRadius: "50%",
                                                        backgroundColor:
                                                          createdByType.color,
                                                        zIndex:
                                                          _vm.isCreatedBySelected(
                                                            createdByType.type
                                                          )
                                                            ? 10
                                                            : 5,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "system-avatar",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "material-icons",
                                                              staticStyle: {
                                                                color: "white",
                                                                "font-size":
                                                                  "22px",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  createdByType.icon
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("div", {
                                                        staticClass:
                                                          "creator-hover-effect",
                                                      }),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "creator-name",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                        " +
                                                          _vm._s(
                                                            createdByType.label
                                                          ) +
                                                          "\n                                                    "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "creator-description",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          createdByType.description
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "creator-section" },
                                      [
                                        _c(
                                          "h5",
                                          {
                                            staticClass:
                                              "creator-section-title",
                                          },
                                          [
                                            _vm._v(
                                              "Kullanıcılar Tarafından Oluşturulanlar"
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "creator-search" },
                                          [
                                            _c("a-input", {
                                              staticClass:
                                                "creator-search-input",
                                              attrs: {
                                                placeholder: "Kullanıcı ara...",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "prefix",
                                                    fn: function () {
                                                      return [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "material-icons search-icon",
                                                          },
                                                          [_vm._v("search")]
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                false,
                                                2038016488
                                              ),
                                              model: {
                                                value: _vm.creatorSearchQuery,
                                                callback: function ($$v) {
                                                  _vm.creatorSearchQuery = $$v
                                                },
                                                expression:
                                                  "creatorSearchQuery",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "assignees-selection creator-users",
                                          },
                                          _vm._l(
                                            _vm.filteredCreatorUsers,
                                            function (user) {
                                              return _c(
                                                "div",
                                                {
                                                  key: user._id,
                                                  staticClass:
                                                    "assignee-container creator-user-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.toggleCreatedBySelection(
                                                        user._id
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      class: [
                                                        "avatar-container",
                                                        {
                                                          selected:
                                                            _vm.isCreatedBySelected(
                                                              user._id
                                                            ),
                                                        },
                                                      ],
                                                      style: {
                                                        border:
                                                          _vm.isCreatedBySelected(
                                                            user._id
                                                          )
                                                            ? "2px solid #47499d"
                                                            : "2px solid transparent",
                                                        borderRadius: "50%",
                                                        backgroundColor:
                                                          "white",
                                                        zIndex:
                                                          _vm.isCreatedBySelected(
                                                            user._id
                                                          )
                                                            ? 10
                                                            : 5,
                                                      },
                                                    },
                                                    [
                                                      _c("Avatar", {
                                                        directives: [
                                                          {
                                                            name: "tippy",
                                                            rawName: "v-tippy",
                                                            value: {
                                                              followCursor: true,
                                                              placement:
                                                                "bottom-end",
                                                              content:
                                                                user.name,
                                                            },
                                                            expression:
                                                              "{\n                                                                followCursor: true,\n                                                                placement: 'bottom-end',\n                                                                content: user.name\n                                                            }",
                                                          },
                                                        ],
                                                        key: 1,
                                                        staticStyle: {
                                                          cursor: "pointer",
                                                        },
                                                        attrs: {
                                                          size: 40,
                                                          username: user.name,
                                                          src: user.gravatar,
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("div", {
                                                        staticClass:
                                                          "creator-hover-effect",
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "assignee-name",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                        " +
                                                          _vm._s(user.name) +
                                                          "\n                                                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.activeFilterTab === "dateRange",
                                    expression:
                                      "activeFilterTab === 'dateRange'",
                                  },
                                ],
                                staticClass: "filter-tab-pane",
                              },
                              [
                                _c("div", { staticClass: "filter-options" }, [
                                  _vm._m(6),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "date-quick-filters" },
                                    [
                                      _c(
                                        "a-button",
                                        {
                                          staticClass:
                                            "quick-filter-btn today-btn",
                                          on: { click: _vm.setDateFilterToday },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "material-icons" },
                                            [_vm._v("today")]
                                          ),
                                          _vm._v(" "),
                                          _c("span", [_vm._v("Bugün")]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-button",
                                        {
                                          staticClass:
                                            "quick-filter-btn week-btn",
                                          on: {
                                            click: _vm.setDateFilterThisWeek,
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "material-icons" },
                                            [_vm._v("view_week")]
                                          ),
                                          _vm._v(" "),
                                          _c("span", [_vm._v("Bu Hafta")]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-button",
                                        {
                                          staticClass:
                                            "quick-filter-btn month-btn",
                                          on: {
                                            click: _vm.setDateFilterThisMonth,
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "material-icons" },
                                            [_vm._v("calendar_today")]
                                          ),
                                          _vm._v(" "),
                                          _c("span", [_vm._v("Bu Ay")]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "date-range-picker-container",
                                    },
                                    [
                                      _vm._m(7),
                                      _vm._v(" "),
                                      _c("a-range-picker", {
                                        key:
                                          "creation-date-picker-" +
                                          _vm.renderKey,
                                        staticClass: "custom-date-picker",
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          placeholder: [
                                            "Başlangıç Tarihi",
                                            "Bitiş Tarihi",
                                          ],
                                          showTime: false,
                                          format: "DD/MM/YYYY",
                                        },
                                        on: {
                                          change: _vm.handleDateRangeChange,
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                          },
                                        },
                                        model: {
                                          value: _vm.selectedDateRange,
                                          callback: function ($$v) {
                                            _vm.selectedDateRange = $$v
                                          },
                                          expression: "selectedDateRange",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.selectedDateRange &&
                                  _vm.selectedDateRange.length === 2
                                    ? _c("div", { staticClass: "date-hint" }, [
                                        _c(
                                          "div",
                                          { staticClass: "date-chip" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "material-icons" },
                                              [_vm._v("event")]
                                            ),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatDateDisplay(
                                                    _vm.selectedDateRange[0]
                                                  )
                                                ) +
                                                  " - " +
                                                  _vm._s(
                                                    _vm.formatDateDisplay(
                                                      _vm.selectedDateRange[1]
                                                    )
                                                  )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._m(8),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.activeFilterTab === "startDateRange",
                                    expression:
                                      "activeFilterTab === 'startDateRange'",
                                  },
                                ],
                                staticClass: "filter-tab-pane",
                              },
                              [
                                _c("div", { staticClass: "filter-options" }, [
                                  _vm._m(9),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "date-quick-filters" },
                                    [
                                      _c(
                                        "a-button",
                                        {
                                          staticClass:
                                            "quick-filter-btn today-btn",
                                          on: {
                                            click: _vm.setStartDateFilterToday,
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "material-icons" },
                                            [_vm._v("today")]
                                          ),
                                          _vm._v(" "),
                                          _c("span", [_vm._v("Bugün")]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-button",
                                        {
                                          staticClass:
                                            "quick-filter-btn week-btn",
                                          on: {
                                            click:
                                              _vm.setStartDateFilterThisWeek,
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "material-icons" },
                                            [_vm._v("view_week")]
                                          ),
                                          _vm._v(" "),
                                          _c("span", [_vm._v("Bu Hafta")]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-button",
                                        {
                                          staticClass:
                                            "quick-filter-btn month-btn",
                                          on: {
                                            click:
                                              _vm.setStartDateFilterThisMonth,
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "material-icons" },
                                            [_vm._v("calendar_today")]
                                          ),
                                          _vm._v(" "),
                                          _c("span", [_vm._v("Bu Ay")]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "date-range-picker-container",
                                    },
                                    [
                                      _vm._m(10),
                                      _vm._v(" "),
                                      _c("a-range-picker", {
                                        key:
                                          "start-date-picker-" + _vm.renderKey,
                                        staticClass: "custom-date-picker",
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          placeholder: ["Başlangıç", "Bitiş"],
                                          showTime: false,
                                          format: "DD/MM/YYYY",
                                        },
                                        on: {
                                          change:
                                            _vm.handleStartDateRangeChange,
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                          },
                                        },
                                        model: {
                                          value: _vm.localStartDateRange,
                                          callback: function ($$v) {
                                            _vm.localStartDateRange = $$v
                                          },
                                          expression: "localStartDateRange",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.localStartDateRange &&
                                  _vm.localStartDateRange.length === 2
                                    ? _c("div", { staticClass: "date-hint" }, [
                                        _c(
                                          "div",
                                          { staticClass: "date-chip" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "material-icons" },
                                              [_vm._v("event")]
                                            ),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatDateDisplay(
                                                    _vm.localStartDateRange[0]
                                                  )
                                                ) +
                                                  " - " +
                                                  _vm._s(
                                                    _vm.formatDateDisplay(
                                                      _vm.localStartDateRange[1]
                                                    )
                                                  )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._m(11),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.activeFilterTab === "endDateRange",
                                    expression:
                                      "activeFilterTab === 'endDateRange'",
                                  },
                                ],
                                staticClass: "filter-tab-pane",
                              },
                              [
                                _c("div", { staticClass: "filter-options" }, [
                                  _vm._m(12),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "date-quick-filters" },
                                    [
                                      _c(
                                        "a-button",
                                        {
                                          staticClass:
                                            "quick-filter-btn today-btn",
                                          on: {
                                            click: _vm.setEndDateFilterToday,
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "material-icons" },
                                            [_vm._v("today")]
                                          ),
                                          _vm._v(" "),
                                          _c("span", [_vm._v("Bugün")]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-button",
                                        {
                                          staticClass:
                                            "quick-filter-btn week-btn",
                                          on: {
                                            click: _vm.setEndDateFilterThisWeek,
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "material-icons" },
                                            [_vm._v("view_week")]
                                          ),
                                          _vm._v(" "),
                                          _c("span", [_vm._v("Bu Hafta")]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-button",
                                        {
                                          staticClass:
                                            "quick-filter-btn month-btn",
                                          on: {
                                            click:
                                              _vm.setEndDateFilterThisMonth,
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "material-icons" },
                                            [_vm._v("calendar_today")]
                                          ),
                                          _vm._v(" "),
                                          _c("span", [_vm._v("Bu Ay")]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "date-range-picker-container",
                                    },
                                    [
                                      _vm._m(13),
                                      _vm._v(" "),
                                      _c("a-range-picker", {
                                        key: "end-date-picker-" + _vm.renderKey,
                                        staticClass: "custom-date-picker",
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          placeholder: ["Başlangıç", "Bitiş"],
                                          showTime: false,
                                          format: "DD/MM/YYYY",
                                        },
                                        on: {
                                          change: _vm.handleEndDateRangeChange,
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                          },
                                        },
                                        model: {
                                          value: _vm.localEndDateRange,
                                          callback: function ($$v) {
                                            _vm.localEndDateRange = $$v
                                          },
                                          expression: "localEndDateRange",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.localEndDateRange &&
                                  _vm.localEndDateRange.length === 2
                                    ? _c("div", { staticClass: "date-hint" }, [
                                        _c(
                                          "div",
                                          { staticClass: "date-chip" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "material-icons" },
                                              [_vm._v("event")]
                                            ),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatDateDisplay(
                                                    _vm.localEndDateRange[0]
                                                  )
                                                ) +
                                                  " - " +
                                                  _vm._s(
                                                    _vm.formatDateDisplay(
                                                      _vm.localEndDateRange[1]
                                                    )
                                                  )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._m(14),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.activeFilterTab === "overdue",
                                    expression: "activeFilterTab === 'overdue'",
                                  },
                                ],
                                staticClass: "filter-tab-pane",
                              },
                              [
                                _c("div", { staticClass: "filter-options" }, [
                                  _vm._m(15),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "overdue-card" }, [
                                    _c(
                                      "div",
                                      { staticClass: "overdue-card-header" },
                                      [
                                        _vm._m(16),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "overdue-title" },
                                          [
                                            _vm._v(
                                              "Süresi dolan görevleri göster"
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("a-checkbox", {
                                          staticClass: "overdue-checkbox",
                                          attrs: { checked: _vm.showOverdue },
                                          on: {
                                            change: function (e) {
                                              return _vm.toggleOverdueFilter(
                                                e.target.checked
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm._m(17),
                                  ]),
                                  _vm._v(" "),
                                  _vm._m(18),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.activeFilterTab === "updateAt",
                                    expression:
                                      "activeFilterTab === 'updateAt'",
                                  },
                                ],
                                staticClass: "filter-tab-pane",
                              },
                              [
                                _c("div", { staticClass: "filter-options" }, [
                                  _vm._m(19),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "date-quick-filters" },
                                    [
                                      _c(
                                        "a-button",
                                        {
                                          staticClass:
                                            "quick-filter-btn today-btn",
                                          on: {
                                            click: _vm.setUpdateAtFilterToday,
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "material-icons" },
                                            [_vm._v("today")]
                                          ),
                                          _vm._v(" "),
                                          _c("span", [_vm._v("Bugün")]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-button",
                                        {
                                          staticClass:
                                            "quick-filter-btn week-btn",
                                          on: {
                                            click:
                                              _vm.setUpdateAtFilterThisWeek,
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "material-icons" },
                                            [_vm._v("view_week")]
                                          ),
                                          _vm._v(" "),
                                          _c("span", [_vm._v("Bu Hafta")]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-button",
                                        {
                                          staticClass:
                                            "quick-filter-btn month-btn",
                                          on: {
                                            click:
                                              _vm.setUpdateAtFilterThisMonth,
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "material-icons" },
                                            [_vm._v("calendar_today")]
                                          ),
                                          _vm._v(" "),
                                          _c("span", [_vm._v("Bu Ay")]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "date-range-picker-container",
                                    },
                                    [
                                      _vm._m(20),
                                      _vm._v(" "),
                                      _c("a-range-picker", {
                                        key:
                                          "update-at-picker-" + _vm.renderKey,
                                        staticClass: "custom-date-picker",
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          placeholder: ["Başlangıç", "Bitiş"],
                                          showTime: false,
                                          format: "DD/MM/YYYY",
                                        },
                                        on: {
                                          change: _vm.handleUpdateAtRangeChange,
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                          },
                                        },
                                        model: {
                                          value: _vm.localUpdateAtRange,
                                          callback: function ($$v) {
                                            _vm.localUpdateAtRange = $$v
                                          },
                                          expression: "localUpdateAtRange",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.localUpdateAtRange &&
                                  _vm.localUpdateAtRange.length === 2
                                    ? _c("div", { staticClass: "date-hint" }, [
                                        _c(
                                          "div",
                                          { staticClass: "date-chip" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "material-icons" },
                                              [_vm._v("event")]
                                            ),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatDateDisplay(
                                                    _vm.localUpdateAtRange[0]
                                                  )
                                                ) +
                                                  " - " +
                                                  _vm._s(
                                                    _vm.formatDateDisplay(
                                                      _vm.localUpdateAtRange[1]
                                                    )
                                                  )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._m(21),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.activeFilterTab === "tags",
                                    expression: "activeFilterTab === 'tags'",
                                  },
                                ],
                                staticClass: "filter-tab-pane",
                              },
                              [
                                _c("div", { staticClass: "filter-options" }, [
                                  _vm._m(22),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "tags-search" },
                                    [
                                      _c("a-input", {
                                        staticClass: "tag-search-input",
                                        attrs: { placeholder: "Etiket ara..." },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "prefix",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "material-icons search-icon",
                                                    },
                                                    [_vm._v("search")]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          2038016488
                                        ),
                                        model: {
                                          value: _vm.tagSearchQuery,
                                          callback: function ($$v) {
                                            _vm.tagSearchQuery = $$v
                                          },
                                          expression: "tagSearchQuery",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.filteredTags.length > 0
                                    ? _c(
                                        "div",
                                        { staticClass: "tags-selection" },
                                        _vm._l(
                                          _vm.filteredTags,
                                          function (tag) {
                                            return _c(
                                              "div",
                                              {
                                                key: tag._id,
                                                staticClass: "tag-card",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toggleTagSelection(
                                                      tag._id
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("div", {
                                                  staticClass: "tag-color",
                                                  style: {
                                                    backgroundColor: tag.color,
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "tag-info" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "tag-name",
                                                      },
                                                      [_vm._v(_vm._s(tag.name))]
                                                    ),
                                                    _vm._v(" "),
                                                    tag.description
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "tag-desc",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                tag.description
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("a-checkbox", {
                                                  staticClass: "tag-checkbox",
                                                  attrs: {
                                                    checked: _vm.isTagSelected(
                                                      tag._id
                                                    ),
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                    },
                                                    change: function (e) {
                                                      return _vm.toggleTagSelection(
                                                        tag._id,
                                                        e.target.checked
                                                      )
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    : _vm.isTagsLoading
                                    ? _c(
                                        "div",
                                        { staticClass: "tags-loading" },
                                        [
                                          _c("a-spin"),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v("Etiketler yükleniyor..."),
                                          ]),
                                        ],
                                        1
                                      )
                                    : _c("div", { staticClass: "tags-empty" }, [
                                        _vm._m(23),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "tags-empty-text" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.tagSearchQuery
                                                  ? "Arama kriterlerine uygun etiket bulunamadı."
                                                  : "Henüz hiç etiket oluşturulmamış."
                                              )
                                            ),
                                          ]
                                        ),
                                      ]),
                                  _vm._v(" "),
                                  _vm._m(24),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.activeFilterTab === "status",
                                    expression: "activeFilterTab === 'status'",
                                  },
                                ],
                                staticClass: "filter-tab-pane",
                              },
                              [
                                _c("div", { staticClass: "filter-options" }, [
                                  _vm._m(25),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "pipeline-search" },
                                    [
                                      _c("a-input", {
                                        staticClass: "pipeline-search-input",
                                        attrs: {
                                          placeholder: "Pipeline ara...",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "prefix",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "material-icons search-icon",
                                                    },
                                                    [_vm._v("search")]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          2038016488
                                        ),
                                        model: {
                                          value: _vm.pipelineSearchQuery,
                                          callback: function ($$v) {
                                            _vm.pipelineSearchQuery = $$v
                                          },
                                          expression: "pipelineSearchQuery",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.filteredPipelines.length > 0
                                    ? _c(
                                        "div",
                                        { staticClass: "pipelines-selection" },
                                        _vm._l(
                                          _vm.filteredPipelines,
                                          function (pipeline) {
                                            return _c(
                                              "div",
                                              {
                                                key: pipeline._id,
                                                class: [
                                                  "pipeline-card",
                                                  {
                                                    selected:
                                                      _vm.isPipelineSelected(
                                                        pipeline._id
                                                      ),
                                                  },
                                                ],
                                                style: _vm.isPipelineSelected(
                                                  pipeline._id
                                                )
                                                  ? {
                                                      borderColor:
                                                        pipeline.color ||
                                                        "#47499d",
                                                    }
                                                  : {},
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.togglePipelineSelection(
                                                      pipeline._id
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("div", {
                                                  staticClass: "pipeline-color",
                                                  style: {
                                                    backgroundColor:
                                                      pipeline.color ||
                                                      "#47499d",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "pipeline-info",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "pipeline-name",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(pipeline.name)
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "pipeline-order",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Sıra: " +
                                                            _vm._s(
                                                              pipeline.order
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    : _vm.isPipelinesLoading
                                    ? _c(
                                        "div",
                                        { staticClass: "pipelines-loading" },
                                        [
                                          _c("a-spin"),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              "Pipeline'lar yükleniyor..."
                                            ),
                                          ]),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "div",
                                        { staticClass: "pipelines-empty" },
                                        [
                                          _vm._m(26),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "pipelines-empty-text",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.pipelineSearchQuery
                                                    ? "Arama kriterlerine uygun pipeline bulunamadı."
                                                    : "Henüz hiç pipeline oluşturulmamış."
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                  _vm._v(" "),
                                  _vm._m(27),
                                ]),
                              ]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-actions" },
                          [
                            _c(
                              "a-button",
                              {
                                attrs: { type: "link" },
                                on: { click: _vm.resetFilters },
                              },
                              [_vm._v("Filtreleri temizle")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.applyFilters },
                              },
                              [_vm._v("Uygula")]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm.showOperations &&
        _vm.showBatchOperations &&
        !!_vm.batchOperationItems.length
          ? _c("div", { staticClass: "batch-operation" }, [
              _c("div", { staticClass: "batch-count" }, [
                _vm._v(_vm._s(_vm.batchOperationItems.length) + " seçili"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "batch-actions" }, [
                _c(
                  "div",
                  {
                    staticClass: "batch-btn",
                    on: {
                      click: function ($event) {
                        return _vm.changeCheckedTasks({
                          target: { checked: !_vm.checkedAllTasks },
                        })
                      },
                    },
                  },
                  [
                    _c("a-checkbox", {
                      staticClass: "kanban-checkbox",
                      attrs: {
                        indeterminate: _vm.checkedAnyTasks,
                        checked: _vm.checkedAllTasks,
                      },
                      on: {
                        change: _vm.changeCheckedTasks,
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "batch-btn",
                    on: {
                      click: function ($event) {
                        return _vm.$emit("change-stage")
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("table_chart"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$t("task.changeStage")))]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "batch-btn",
                    on: {
                      click: function ($event) {
                        return _vm.$emit("delete-tasks")
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("delete"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$t("chatbotv2.delete")))]),
                  ]
                ),
                _vm._v(" "),
                _vm.canCloseTasks
                  ? _c(
                      "div",
                      {
                        staticClass: "batch-btn close-task-btn",
                        on: {
                          click: function ($event) {
                            return _vm.$emit("close-tasks")
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("check_circle"),
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v("Görevi Kapat")]),
                      ]
                    )
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._t("right-buttons"),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "priority-info" }, [
      _c("h4", [_vm._v("Görev Önceliği Seçimi")]),
      _vm._v(" "),
      _c("p", { staticClass: "priority-description-text" }, [
        _vm._v(
          "\n                                                Görevlerin öncelik seviyesine göre filtreleme yapabilirsiniz.\n                                                İstediğiniz öncelik seviyelerini seçerek görevleri filtreleyebilirsiniz.\n                                            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "priority-info-card" }, [
      _c("div", { staticClass: "priority-info-header" }, [
        _c("span", { staticClass: "material-icons info-icon" }, [
          _vm._v("info"),
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("Öncelik Seviyeleri Hakkında")]),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "priority-info-text" }, [
        _vm._v(
          "\n                                                Öncelik seviyeleri, görevlerin önem derecesini belirtir.\n                                                Yüksek öncelikli görevler ekibinizin daha önce odaklanması gereken işleri gösterirken,\n                                                düşük öncelikli görevler daha az aciliyet gerektiren işleri belirtir.\n                                            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "assignees-info" }, [
      _c("h4", [_vm._v("Kullanıcı Seçimi")]),
      _vm._v(" "),
      _c("p", { staticClass: "assignees-description" }, [
        _vm._v(
          "\n                                                Göreve atanan kullanıcılara göre filtreleme yapabilirsiniz.\n                                                İstediğiniz kullanıcıları seçerek, sadece onlara atanan görevleri görebilirsiniz.\n                                            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "assignees-info" }, [
      _c("h4", [_vm._v("Görev Sahibi Seçimi")]),
      _vm._v(" "),
      _c("p", { staticClass: "assignees-description" }, [
        _vm._v(
          "\n                                                Görev sahiplerine göre filtreleme yapabilirsiniz.\n                                                İstediğiniz kullanıcıları seçerek, sadece onların sahip olduğu görevleri görebilirsiniz.\n                                            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "assignees-info" }, [
      _c("h4", [_vm._v("Görev Takipçileri Seçimi")]),
      _vm._v(" "),
      _c("p", { staticClass: "assignees-description" }, [
        _vm._v(
          "\n                                                Görev takipçilerine göre filtreleme yapabilirsiniz.\n                                                İstediğiniz kullanıcıları seçerek, sadece takip ettikleri görevleri görebilirsiniz.\n                                            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "assignees-info" }, [
      _c("h4", [_vm._v("Görevi Oluşturan Seçimi")]),
      _vm._v(" "),
      _c("p", { staticClass: "assignees-description" }, [
        _vm._v(
          "\n                                                Görevi oluşturan kişi veya sisteme göre filtreleme yapabilirsiniz.\n                                                İstediğiniz kullanıcıları veya sistem türlerini seçerek, görevleri filtreleyebilirsiniz.\n                                            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "date-range-info" }, [
      _c("h4", [_vm._v("Oluşturulma Tarihine Göre Filtrele")]),
      _vm._v(" "),
      _c("p", { staticClass: "date-range-description" }, [
        _vm._v(
          "\n                                                Seçtiğiniz tarih aralığında oluşturulan görevleri filtrelemek için başlangıç ve bitiş tarihlerini belirleyin.\n                                                Bu filtre, görevlerin oluşturulma tarihine (createdAt) göre filtreleme yapar.\n                                            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "date-range-icon" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v("date_range")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "date-info-card" }, [
      _c("div", { staticClass: "date-info-header" }, [
        _c("span", { staticClass: "material-icons info-icon" }, [
          _vm._v("info"),
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("Tarih Filtresi Hakkında")]),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "date-info-text" }, [
        _vm._v(
          "\n                                                Tarih filtresi, görevlerin oluşturulma tarihine göre sonuçları sınırlandırır.\n                                                Böylece belirli bir zaman diliminde oluşturulmuş görevleri kolayca bulabilirsiniz.\n                                            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "date-range-info" }, [
      _c("h4", [_vm._v("Başlangıç Tarihine Göre Filtrele")]),
      _vm._v(" "),
      _c("p", { staticClass: "date-range-description" }, [
        _vm._v(
          "\n                                                Seçtiğiniz tarih aralığında oluşturulan görevleri filtrelemek için başlangıç tarihini belirleyin.\n                                                Bu filtre, görevlerin başlangıç tarihine (startDate) göre filtreleme yapar.\n                                            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "date-range-icon" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v("date_range")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "date-info-card" }, [
      _c("div", { staticClass: "date-info-header" }, [
        _c("span", { staticClass: "material-icons info-icon" }, [
          _vm._v("info"),
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("Tarih Filtresi Hakkında")]),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "date-info-text" }, [
        _vm._v(
          "\n                                                Tarih filtresi, görevlerin başlangıç tarihine göre sonuçları sınırlandırır.\n                                                Böylece belirli bir zaman aralığında başlayacak olan görevleri kolayca bulabilirsiniz.\n                                            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "date-range-info" }, [
      _c("h4", [_vm._v("Bitiş Tarihine Göre Filtrele")]),
      _vm._v(" "),
      _c("p", { staticClass: "date-range-description" }, [
        _vm._v(
          "\n                                                Seçtiğiniz tarih aralığında oluşturulan görevleri filtrelemek için bitiş tarihini belirleyin.\n                                                Bu filtre, görevlerin bitiş tarihine (endDate) göre filtreleme yapar.\n                                            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "date-range-icon" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v("date_range")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "date-info-card" }, [
      _c("div", { staticClass: "date-info-header" }, [
        _c("span", { staticClass: "material-icons info-icon" }, [
          _vm._v("info"),
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("Tarih Filtresi Hakkında")]),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "date-info-text" }, [
        _vm._v(
          "\n                                                Tarih filtresi, görevlerin bitiş tarihine göre sonuçları sınırlandırır.\n                                                Böylece belirli bir zaman aralığında bitecek olan görevleri kolayca bulabilirsiniz.\n                                            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "overdue-info" }, [
      _c("h4", [_vm._v("Süresi Dolan Görevler")]),
      _vm._v(" "),
      _c("p", { staticClass: "overdue-description-text" }, [
        _vm._v(
          "\n                                                Teslim tarihi geçmiş ve hala tamamlanmamış görevleri filtreleyebilirsiniz.\n                                                Bu filtre aktif olduğunda, sadece süresi dolan görevler görüntülenecektir.\n                                            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "overdue-icon-wrapper" }, [
      _c("span", { staticClass: "material-icons overdue-icon" }, [
        _vm._v("alarm"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "overdue-card-body" }, [
      _c("p", { staticClass: "overdue-detail" }, [
        _vm._v(
          "\n                                                    Teslim tarihi geçmiş ve hala tamamlanmamış görevler, bu filtre aktif olduğunda görüntülenecektir.\n                                                    Bu görevler genellikle ekibinizin en kısa sürede ilgilenmesi gereken görevlerdir.\n                                                "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "overdue-info-card" }, [
      _c("div", { staticClass: "overdue-info-header" }, [
        _c("span", { staticClass: "material-icons info-icon" }, [
          _vm._v("info"),
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("Önemli Bilgi")]),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "overdue-info-text" }, [
        _vm._v(
          "\n                                                Süresi dolan görevler, teslim tarihi geçtiği halde tamamlanmamış görevlerdir.\n                                                Bu görevler, ekibinizin dikkatini çekmesi gereken önemli işleri gösterir.\n                                            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "date-range-info" }, [
      _c("h4", [_vm._v("Güncellenme Tarihine Göre Filtrele")]),
      _vm._v(" "),
      _c("p", { staticClass: "date-range-description" }, [
        _vm._v(
          "\n                                                Seçtiğiniz tarih aralığında güncellenmiş görevleri filtrelemek için başlangıç ve bitiş tarihlerini belirleyin.\n                                                Bu filtre, görevlerin güncellenme tarihine (updatedAt) göre filtreleme yapar.\n                                            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "date-range-icon" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v("date_range")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "date-info-card" }, [
      _c("div", { staticClass: "date-info-header" }, [
        _c("span", { staticClass: "material-icons info-icon" }, [
          _vm._v("info"),
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("Tarih Filtresi Hakkında")]),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "date-info-text" }, [
        _vm._v(
          "\n                                                Tarih filtresi, görevlerin son güncellenme tarihine göre sonuçları sınırlandırır.\n                                                Böylece belirli bir zaman aralığında güncellenmiş görevleri kolayca bulabilirsiniz.\n                                            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tags-info" }, [
      _c("h4", [_vm._v("Görev Etiketleri")]),
      _vm._v(" "),
      _c("p", { staticClass: "tags-description-text" }, [
        _vm._v(
          "\n                                                Görevleri etiketlerine göre filtreleyebilirsiniz.\n                                                Seçtiğiniz etiketlere sahip görevler görüntülenecektir.\n                                            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tags-empty-icon" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v("label_off")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tags-info-card" }, [
      _c("div", { staticClass: "tags-info-header" }, [
        _c("span", { staticClass: "material-icons info-icon" }, [
          _vm._v("info"),
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("Etiketler Hakkında")]),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "tags-info-text" }, [
        _vm._v(
          "\n                                                Etiketler, görevleri kategorize etmenize ve daha kolay bulmanıza yardımcı olur.\n                                                Birden fazla etiket seçerseniz, seçilen etiketlerden herhangi birine sahip görevler gösterilecektir.\n                                            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pipeline-info" }, [
      _c("h4", [_vm._v("Pipeline Durumu Seçimi")]),
      _vm._v(" "),
      _c("p", { staticClass: "pipeline-description-text" }, [
        _vm._v(
          "\n                                                Görevleri pipeline durumlarına göre filtreleyebilirsiniz.\n                                                İstediğiniz pipeline'ları seçerek, sadece o aşamalardaki görevleri görebilirsiniz.\n                                            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pipelines-empty-icon" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v("view_column")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pipelines-info-card" }, [
      _c("div", { staticClass: "pipelines-info-header" }, [
        _c("span", { staticClass: "material-icons info-icon" }, [
          _vm._v("info"),
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("Pipeline'lar Hakkında")]),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "pipelines-info-text" }, [
        _vm._v(
          "\n                                                Pipeline'lar, görevlerin hangi aşamada olduğunu gösterir.\n                                                Birden fazla pipeline seçerseniz, seçilen pipeline'lardan herhangi birinde bulunan görevler gösterilecektir.\n                                            "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }